// extracted by mini-css-extract-plugin
export var md = "_2o-4";
export var semantic = "_2o-5";
export var sm = "_2o-3";
export var text = "_2o-6";
export var toggleInput = "_2o-0";
export var toggleSwitch = "_2o-1";
export var xs = "_2o-2";